/**
 * Which classic strategy a prioritization cycle supports.
 *
 * A cycle names its strategy on itself (`degap_cycles.strategy_ref`); older
 * links run the other way, the strategy listing the cycle in
 * `strategies.linked_cycle_ids`. The cycle's own reference wins; the strategy's
 * list is the fallback. A reference to another kind of strategy (an opportunity
 * tree, a kernel, a canvas, a V2MOM) names no classic strategy, so only the
 * fallback can answer for it.
 *
 * One rule, read by the session's driver alignment and by the Plan Audit.
 */

export interface CycleStrategyCandidate {
  id: string;
  linkedCycleIds?: readonly string[] | null;
}

/** The id of the classic strategy the cycle supports, or null when it supports none. */
export function strategyIdForCycle(
  cycleId: string,
  strategyRef: { id?: string | null } | null | undefined,
  strategies: Iterable<CycleStrategyCandidate>,
): string | null {
  const list = [...strategies];
  const byRef = strategyRef?.id ? list.find((s) => s.id === strategyRef.id) : undefined;
  return (byRef ?? list.find((s) => s.linkedCycleIds?.includes(cycleId)))?.id ?? null;
}
